var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CheckRounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.00014 16.1703L5.53014 12.7003C5.14014 12.3103 4.51014 12.3103 4.12014 12.7003C3.73014 13.0903 3.73014 13.7203 4.12014 14.1103L8.30014 18.2903C8.69014 18.6803 9.32014 18.6803 9.71014 18.2903L20.2901 7.71031C20.6801 7.32031 20.6801 6.69031 20.2901 6.30031C19.9001 5.91031 19.2701 5.91031 18.8801 6.30031L9.00014 16.1703Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.10590587f3b494727a7b0b2ba4c295ca.svg";
export { ForwardRef as ReactComponent };